import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../Assets/newlogo-optimized.webp";
import whastap from "../Assets/whtsapp.webp";
import { Button } from "react-bootstrap";
function Navbar() {
  const [isDivVisible, setIsDivVisible] = useState(false);
  const [user, setUser] = useState(null);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isMoreOpen, setIsMoreOpen] = useState(false);
  const toggleDivRef = useRef(null);
  const profileRef = useRef(null);
  const moreRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const mobileLinks = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About Us" },
    { to: "/services", label: "Services" },
    { to: "/contact", label: "Contact Us" },
    { to: "/blog", label: "Blogs" },
    { to: "/gallery", label: "Gallery" },
  ];
  const moreLinks = [
    { to: "/tnc", label: "Terms & Conditions" },
    { to: "/faq", label: "FAQ" },
    { to: "/refund", label: "Refund Policy" },
    { to: "/policy", label: "Privacy Policy" },
  ];
  const hideBookNowButton =
    location.pathname.startsWith("/slot-detail/") ||
    location.pathname === "/booknow";

  useEffect(() => {
    const storedUser = localStorage.getItem("cine_user");
    const storedToken = localStorage.getItem("cine_userToken");
    if (storedUser && storedToken) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleClickOutside = (event) => {
    if (toggleDivRef.current && !toggleDivRef.current.contains(event.target)) {
      setIsDivVisible(false);
    }
    if (profileRef.current && !profileRef.current.contains(event.target)) {
      setIsProfileOpen(false);
    }
    if (moreRef.current && !moreRef.current.contains(event.target)) {
      setIsMoreOpen(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("cine_user");
    localStorage.removeItem("cine_userToken");
    setUser(null);
    setIsDivVisible(false);
    navigate("/login");
  };

  const closeMobileMenu = () => setIsDivVisible(false);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    setIsDivVisible(false);
    setIsProfileOpen(false);
    setIsMoreOpen(false);
  }, [location.pathname]);

  return (
    <>
      <div className="site-header-wrap">
        <Link to="/" className="site-header__brand">
          <img className="cinelogo" src={logo} alt="Cine Celebrate logo" />
        </Link>
        <nav className="site-header">
        <ul className="site-header__nav">
          <NavLink exact to="/" className="none site-header__link" activeClassName="active">
            <li>Home</li>
          </NavLink>
          <NavLink to="/about" className="none site-header__link" activeClassName="active">
            <li>About Us</li>
          </NavLink>
          <NavLink to="/services" className="none site-header__link" activeClassName="active">
            <li>Services</li>
          </NavLink>
          <NavLink to="/gallery" className="none site-header__link" activeClassName="active">
            <li>Gallery</li>
          </NavLink>
          {!hideBookNowButton && (
            <NavLink to="/booknow" className="none site-header__cta-link" activeClassName="nav-active">
              <Button className="book-now-btn site-header__cta">
                Book Now
              </Button>
            </NavLink>
          )}
          <NavLink to="/contact" className="none site-header__link" activeClassName="active">
            <li>Contact Us</li>
          </NavLink>
          <NavLink to="/blog" className="none site-header__link" activeClassName="active">
            <li>Blogs</li>
          </NavLink>
          <div className="site-header__more" ref={moreRef}>
            <div
              role="button"
              tabIndex={0}
              className={`site-header__link site-header__more-trigger ${
                isMoreOpen ? "active" : ""
              }`}
              onClick={() => setIsMoreOpen(!isMoreOpen)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  setIsMoreOpen(!isMoreOpen);
                }
              }}
            >
              <span>More</span>
            </div>

            {isMoreOpen && (
              <div className="site-header__more-menu">
                {moreLinks.map((link) => (
                  <NavLink
                    key={link.to}
                    to={link.to}
                    className="site-header__more-link"
                  >
                    {link.label}
                  </NavLink>
                ))}
              </div>
            )}
          </div>
          <div className="profile-container site-header__account" ref={profileRef}>
            {user ? (
              <div className="profile-dropdown">
                <div
                  role="button"
                  tabIndex={0}
                  className="site-header__link site-header__profile-trigger"
                  onClick={() => setIsProfileOpen(!isProfileOpen)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      setIsProfileOpen(!isProfileOpen);
                    }
                  }}
                >
                  <span className="site-header__profile-label">Profile</span>
                </div>

                {isProfileOpen && (
                  <div className="profile-options">
                    <ul>
                      <li onClick={() => navigate("/profile")}>Profile</li>
                      <li onClick={handleLogout}>Logout</li>
                    </ul>
                  </div>
                )}
              </div>
            ) : (
              <Link to="/login" className="login-button site-header__login">
                <span>Login</span>
              </Link>
            )}
          </div>
        </ul>

        <div className="mobile-right">
          {!hideBookNowButton && (
            <NavLink to="/booknow" className="none site-header__mobile-cta-link" activeClassName="nav-active">
              <Button className="book-now-btn site-header__mobile-cta">
                Book Now
              </Button>
            </NavLink>
          )}

          <i
            className={`bi ${isDivVisible ? "bi-x-lg" : "bi-list"} hamburger`}
            onClick={() => setIsDivVisible(!isDivVisible)}
          ></i>
        </div>
        </nav>
      </div>
      {isDivVisible && (
        <div className="toggleDiv-ops" onClick={closeMobileMenu}>
          <div
            className="toggleDiv"
            ref={toggleDivRef}
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="toggleDiv__close"
              onClick={closeMobileMenu}
              aria-label="Close menu"
            >
              <i className="bi bi-x-lg"></i>
            </button>

            <div className="toggleDiv__intro">
              <p>Menu</p>
              <strong>Cine Celebrate</strong>
              <span>Quick access to pages, booking, and your account.</span>
            </div>

            <ul className="toggleDiv__links">
              {mobileLinks.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  onClick={closeMobileMenu}
                  className={({ isActive }) =>
                    isActive ? "active-link none2" : "none2"
                  }
                >
                  <li>{link.label}</li>
                </NavLink>
              ))}

              {!hideBookNowButton && (
                <NavLink
                  to="/booknow"
                  onClick={closeMobileMenu}
                  className={({ isActive }) =>
                    isActive ? "active-link none2 none2--cta" : "none2 none2--cta"
                  }
                >
                  <li>Book Now</li>
                </NavLink>
              )}

              {moreLinks.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  onClick={closeMobileMenu}
                  className={({ isActive }) =>
                    isActive ? "active-link none2" : "none2"
                  }
                >
                  <li>{link.label}</li>
                </NavLink>
              ))}
            </ul>

            <div className="toggleDiv__account">
              {user ? (
                <>
                  <button type="button" onClick={() => { closeMobileMenu(); navigate("/profile"); }}>
                    Profile
                  </button>
                  <button type="button" onClick={handleLogout}>
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <NavLink to="/login" onClick={closeMobileMenu} className="toggleDiv__account-link">
                    Login
                  </NavLink>
                  <NavLink to="/signup" onClick={closeMobileMenu} className="toggleDiv__account-link toggleDiv__account-link--primary">
                    Create Account
                  </NavLink>
                </>
              )}
            </div>
          </div>
        </div>
      )}
      <Link to="https://wa.me/919643055509">
        <img className="stat" src={whastap} />
      </Link>
    </>
  );
}

export default Navbar;
